import StatLabel from './StatLabel'

export default StatLabel
